import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { FETCH_CREATOR_ACTIVE_PLAN_API } from "features/Account/Account.constants";

export const useActivePlan = () =>
  useCustomQuery({
    url: FETCH_CREATOR_ACTIVE_PLAN_API,
    queryKey: [FETCH_CREATOR_ACTIVE_PLAN_API],
  });
